import {IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import Modal from './Modal';
import Confirmation from './Confirmation';

const ConfirmationModal = ({children, onConfirm, onCancel}) => {
    return (
        <Modal className="confirmation-modal">
            <IconButton aria-label="close" onClick={onCancel} className="close-btn">
                <Close />
            </IconButton>
            <Confirmation onConfirmation={onConfirm} onCancellation={onCancel}>
                {children}
            </Confirmation>
        </Modal>
    );
};

export default ConfirmationModal;
